import { render, staticRenderFns } from "./kdzy.vue?vue&type=template&id=0d7cf9f5&scoped=true&"
import script from "./kdzy.vue?vue&type=script&lang=ts&"
export * from "./kdzy.vue?vue&type=script&lang=ts&"
import style0 from "./kdzy.vue?vue&type=style&index=0&id=0d7cf9f5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d7cf9f5",
  null
  
)

export default component.exports